import { SIM_BUILDER_API_END_POINT } from "../Config";
import RequestService, { HttpMethods } from "../utils/requestService";
import { UploadS3Files } from "./S3UplodService";
import authFetch from "../utils/authFetch";

const S3Service = () => {
  return Object.freeze({
    getSigendUrlForView: async (
      objectKey,
      contentType,
      token,
      bucketName = null
    ) => {
      const options = RequestService.makeRequest(HttpMethods.POST, token);
      options["body"] = JSON.stringify({ objectKey, contentType, bucketName });

      const result = await authFetch(
        SIM_BUILDER_API_END_POINT + "/awsS3/getSignedUrlForView",
        options
      );
      const response = await result.json();

      return response;
    },
    
    saveStudentRecordedResponse: async (file, simId) => {
      if (file !== null) {
        const promises = await UploadS3Files(file, `${simId}/studentResponse/`);
        return promises?.fileKey;
      }
    },
  });
};

export default S3Service;
